/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PostCollaborationToolTemplateDomainTestRequestDto = {
    domainId: string;
    type: PostCollaborationToolTemplateDomainTestRequestDto.type;
};

export namespace PostCollaborationToolTemplateDomainTestRequestDto {

    export enum type {
        JIRA = 'JIRA',
        SERVICENOW = 'SERVICENOW',
    }


}
